import SettingsMain from './SettingsMain'

export default {
  SettingsMain,
}
